import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Building2, CheckCircle2 } from "lucide-react";
import { useState } from "react";

interface Empresa {
  id: number;
  nome: string;
  nome_fantasia: string;
  cnpj: string;
  logo?: string;
  tipo_empresa: "MATRIZ" | "FILIAL";
}

interface ModalSelecaoEmpresaProps {
  open: boolean;
  empresas: Empresa[];
  onSelect: (empresaId: number) => void;
  loading?: boolean;
}

export function ModalSelecaoEmpresa({
  open,
  empresas,
  onSelect,
  loading = false,
}: ModalSelecaoEmpresaProps) {
  const [empresaSelecionada, setEmpresaSelecionada] = useState<number | null>(
    null
  );

  const handleConfirmar = () => {
    if (empresaSelecionada) {
      onSelect(empresaSelecionada);
    }
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Building2 className="h-5 w-5" />
            Selecione a Empresa
          </DialogTitle>
          <DialogDescription>
            Você tem acesso a múltiplas empresas. Selecione uma para continuar.
          </DialogDescription>
        </DialogHeader>

        <div className="grid gap-3 py-4">
          {empresas.map((empresa) => (
            <button
              key={empresa.id}
              onClick={() => setEmpresaSelecionada(empresa.id)}
              className={`flex items-center justify-between p-4 border rounded-lg transition-all hover:border-primary ${
                empresaSelecionada === empresa.id
                  ? "border-primary bg-primary/5"
                  : "border-border"
              }`}
            >
              <div className="flex items-center gap-3">
                {empresa.logo ? (
                  <img
                    src={empresa.logo}
                    alt={empresa.nome}
                    className="h-10 w-10 rounded object-contain"
                  />
                ) : (
                  <div className="h-10 w-10 rounded bg-muted flex items-center justify-center">
                    <Building2 className="h-5 w-5 text-muted-foreground" />
                  </div>
                )}
                <div className="text-left">
                  <p className="font-medium">{empresa.nome_fantasia}</p>
                  <p className="text-sm text-muted-foreground">
                    CNPJ: {empresa.cnpj}
                  </p>
                  {empresa.tipo_empresa === "FILIAL" && (
                    <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded">
                      Filial
                    </span>
                  )}
                </div>
              </div>

              {empresaSelecionada === empresa.id && (
                <CheckCircle2 className="h-5 w-5 text-primary" />
              )}
            </button>
          ))}
        </div>

        <div className="flex justify-end gap-2">
          <Button
            onClick={handleConfirmar}
            disabled={!empresaSelecionada || loading}
          >
            {loading ? "Carregando..." : "Confirmar"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ModalSelecaoEmpresa;
